import { EmailClientDto } from "@/entities/email";
import { Api } from './api/axios-config';
import { EmailFormData } from "@/entities/emailFormData";

export class EmailService {

  private static api = Api();

  public static async sendEmailClient(email: EmailClientDto) {
    const response = await this.api.post<any>('emails/sendClient', {
      nome: email.nome,
      telefone: email.telefone,
      atividade: email.atividade,
      email: email.email,
      data: email.data,
      uf: email.uf,
      cidade: email.cidade,
      hora_ini: email.hora_ini,
      hora_fim: email.hora_fim,
    });
    if (response.status === 201) {
      return response.data;
    }
    return null;
  }
  public static async getEmailConfig(userId: number) {
    try {
      const response = await this.api.get(`/emails/config/${userId}`)
      if (response) {
        return response.data;
      }
    } catch (e) {
      console.error(e);
    }
  }
  public static async getTemplates() {
    try {
      const response = await this.api.get(`/templates`)
      if (response) {
        return response.data;
      }
    } catch (e) {
      console.error(e);
    }
  }
  public static async sendEmail(data: FormData) {
    try {
      const response = await this.api.post(`/emails/send`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (response) {
        return response;
      }
    } catch (e) {
      console.error(e);
    }
  }
  public static async addEmailConfig(userId: number, email: string, password: string) {
    try {
      const response = await this.api.post(`emails/config`, {
        userId: userId,
        email: email,
        password: password,
      })
      if (response) {
        return response;
      }
    } catch (e) {
      console.error(e);
    }

  }
}